;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React, { useState } from 'react';

import { Modal } from 'reactstrap';

import ProfileModalIntro from './ProfileModalIntro';
import ProfileModalFunctions from './ProfileModalFunctions';
import ProfileModalMaxDistance from './ProfileModalMaxDistance';
import ProfileModalContractType from './ProfileModalContractType';
import ProfileModalProgress from './ProfileModalProgress';
import ProfileModalLaborRegime from './ProfileModalLaborRegime';
import ProfileModalResume from './ProfileModalResume';
import ProfileModalEmail from './ProfileModalEmail';
import ProfileModalOutro from './ProfileModalOutro';
import { Dictionaries } from '../../../i18n/i18n-config';

type Props = {
  isOpen?: boolean;
  toggle: () => void;
  dictionary: Partial<Dictionaries>;
};
const ProfileModal = ({ isOpen = true, toggle, dictionary }: Props): JSX.Element => {
  const [step, setStep] = useState(0);

  const navigate = (direction: 'next' | 'prev') =>
    setStep((prev) => {
      const nextStep = direction === 'next' ? prev + 1 : prev - 1;
      return nextStep;
    });

  return (
    <Modal isOpen={isOpen} id="profile-modal" toggle={toggle}>
      {step > 0 && step < 7 && <ProfileModalProgress dictionary={dictionary} step={step} />}
      {(() => {
        switch (step) {
          case 0:
            return <ProfileModalIntro dictionary={dictionary} toggle={toggle} next={() => navigate('next')} />;
          case 1:
            return <ProfileModalFunctions dictionary={dictionary} next={() => navigate('next')} prev={() => navigate('prev')} />;
          case 2:
            return (
              <ProfileModalMaxDistance dictionary={dictionary} next={() => navigate('next')} prev={() => navigate('prev')} />
            );
          case 3:
            return (
              <ProfileModalContractType dictionary={dictionary} next={() => navigate('next')} prev={() => navigate('prev')} />
            );
          case 4:
            return (
              <ProfileModalLaborRegime dictionary={dictionary} next={() => navigate('next')} prev={() => navigate('prev')} />
            );
          case 5:
            return <ProfileModalResume dictionary={dictionary} next={() => navigate('next')} prev={() => navigate('prev')} />;
          case 6:
            return <ProfileModalEmail dictionary={dictionary} next={() => navigate('next')} prev={() => navigate('prev')} />;
          case 7:
            return <ProfileModalOutro dictionary={dictionary} toggle={toggle} />;
          default:
            break;
        }
      })()}
    </Modal>
  );
};

export default ProfileModal;
